import { useNavigate, useParams } from "react-router-dom";
import { RouteTypes } from "hooks/utils/util";
import { useGetConsolePopupDetail } from "hooks/console/useGetConsolePopupDetail";
import { useEffect, useState } from "react";
import PopupForm, { PopupFormProps } from "./PopupForm";
import LoadingPop from "components/popup/LoadingPop";
import PageHeader from "../-components/PageHeader";
import Seo from "components/Seo";

const initialForm = {
    category: "",
    idx: null,
    vTitle: "",
    vPopSizeW: "300",
    vPopSizeH: "400",
    vPopX: "550",
    vPopY: "250",
    cViewYN: "Y",
    cTodayYN: "N",
    cPvL: "L",
    vContent: "",
};
export default function ConsolePopupDetail({ type }: { type: RouteTypes }) {
    const params = useParams();
    const idx = params.idx;
    const { data, isLoading } = useGetConsolePopupDetail({ category: type, idx: idx ?? "" });
    const [form, setForm] = useState<PopupFormProps>(initialForm);
    const navigate = useNavigate();

    useEffect(() => {
        if (data && idx) {
            setForm(prev => ({
                idx: idx,
                category: type,
                vTitle: data.vTitle,
                vPopSizeW: data.vPopSizeW.toString(),
                vPopSizeH: data.vPopSizeH.toString(),
                vPopX: data.vPopX.toString(),
                vPopY: data.vPopY.toString(),
                cViewYN: data.cViewYN,
                cTodayYN: data.cTodayYN,
                cPvL: data.cPvL,
                vContent: data.vContent,
            }));
        }
    }, [data]);

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="팝업수정" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="팝업수정" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className=" px-[40px] py-[28px] w-full overflow-auto">
                        {isLoading ? (
                            <LoadingPop />
                        ) : (
                            <>
                                {data ? (
                                    <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                        <PopupForm type={type} form={form} setForm={setForm} update />
                                    </div>
                                ) : (
                                    <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                        <p>결과가 없습니다.</p>
                                        <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                            뒤로가기
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
